module.exports = __webpack_public_path__ + "static/media/logo-hydrafacial.c9b23bbb.svg";